import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import "./Assets/css/styles.css";
import "./Assets/font/stylesheet.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "video-react/dist/video-react.css";
import "animate.css";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<>
<Toaster position="top-right" reverseOrder={false} />
<App />
</>


);
